import { motion } from 'framer-motion'
import { useHandCombinationTranslation } from 'hooks/useHandCombinationTranslation'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '../../Typography'
import { Combination } from '../CardHolder.styles'
import { CombinationDisplay } from '../CardHolder.types'

type Props = {
  combination: CombinationDisplay
  animate?: boolean
  visible?: boolean
}

const CombinationLabel: FC<Props> = ({
  combination,
  animate = false,
  visible = true,
}) => {
  const { t } = useTranslation()
  const { getCombinationLabel } = useHandCombinationTranslation()

  if (!visible) return null
  if (combination.type === 'none') return null

  const label =
    combination.type === 'noGame'
      ? t('noGame')
      : `${getCombinationLabel(combination.handName)}${
          combination.extraHandName
            ? ` + ${getCombinationLabel(combination.extraHandName)}`
            : ''
        }`

  if (!animate) {
    return (
      <Combination>
        <Typography variant="gameInfo" color="green">
          {label}
        </Typography>
      </Combination>
    )
  }

  return (
    <Combination>
      <motion.div
        key="combination-reveal"
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: [0, 1, 1, 0.35, 1], y: [6, 0, 0, 0, 0] }}
        transition={{
          duration: 1.0,
          ease: 'easeOut',
          times: [0, 0.3, 0.5, 0.7, 1.0],
        }}>
        <Typography variant="gameInfo" color="green">
          {label}
        </Typography>
      </motion.div>
    </Combination>
  )
}

export default CombinationLabel
